module.exports = __webpack_public_path__ + "mary_ma.png?264ec38236fca7d3e81e8c9f47395e09";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/mary_ma.png
// module id = 71
// module chunks = 0